/*
 * Opens the photoreal flow over the product page instead of navigating to it.
 *
 * The flow itself is Blazon's page, served through the app proxy; this only
 * frames it, so there is one implementation of the flow and not two. If the
 * script fails to load, the button is still a link and still works.
 */
(function () {
  var SELECTOR = 'a[href*="/apps/blazon/photoreal"]';

  function close(overlay) {
    overlay.remove();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', overlay._onKey);
  }

  function open(href, title) {
    var overlay = document.createElement('div');
    overlay.className = 'sb-modal';
    overlay.innerHTML =
      '<div class="sb-modal__box" role="dialog" aria-modal="true" aria-label="' + (title || 'Customize') + '">' +
      '<button class="sb-modal__close" type="button" aria-label="Close">&times;</button>' +
      '<iframe class="sb-modal__frame" src="' + href + '" title="Customize"></iframe>' +
      '</div>';

    overlay.addEventListener('click', function (e) {
      // The backdrop closes; a click inside the dialog must not.
      if (e.target === overlay || e.target.classList.contains('sb-modal__close')) close(overlay);
    });
    overlay._onKey = function (e) { if (e.key === 'Escape') close(overlay); };
    document.addEventListener('keydown', overlay._onKey);

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }

  // The href is written when the page renders, so it names whichever variant
  // was selected THEN. A customer who switches to White and clicks would
  // otherwise be shown Navy.
  function currentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var field = form && form.querySelector('[name="id"]');
    if (field && field.value) return field.value;
    var url = new URL(window.location.href);
    return url.searchParams.get('variant');
  }

  function withCurrentVariant(href) {
    var id = currentVariantId();
    if (!id) return href;
    var url = new URL(href, window.location.origin);
    url.searchParams.set('variant', String(id).split('/').pop());
    return url.pathname + url.search;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!link) return;
    // Let a middle-click or cmd-click open the flow in its own tab.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    open(withCurrentVariant(link.getAttribute('href')), document.title);
  });

  // The flow asks to be closed once the design is in the cart.
  window.addEventListener('message', function (e) {
    if (!e.data || e.data.type !== 'SPECB2B_PHOTOREAL') return;
    var overlay = document.querySelector('.sb-modal');
    if (!overlay) return;
    if (e.data.action === 'close') close(overlay);
    if (e.data.action === 'cart') window.location.href = '/cart';
  });
})();
